import { Radio, Plus } from 'lucide-react'
import { useNavigate } from 'react-router-dom'

export function SeriesEmptyState() {
  const navigate = useNavigate()

  return (
    <div className="flex flex-col items-center justify-center py-20 text-center">
      <div className="mb-6 flex h-20 w-20 items-center justify-center rounded-2xl bg-gradient-to-br from-brand-100 to-brand-200">
        <Radio className="h-10 w-10 text-brand-500" />
      </div>

      <h2 className="mb-2 text-xl font-bold text-foreground">Your personal podcast, delivered automatically</h2>
      <p className="mb-8 max-w-sm text-sm text-foreground/50">
        Tell us what you're interested in. We'll find the best content, generate episodes, and deliver them to your
        podcast app on autopilot.
      </p>

      <button
        onClick={() => navigate('/series/new')}
        className="flex cursor-pointer items-center gap-2 rounded-xl bg-brand-600 px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-brand-700"
      >
        <Plus className="h-4 w-4" />
        Create your first series
      </button>
    </div>
  )
}
